import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Majblomman" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "Majblomman__Logo" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M59.8819 32.6654H56.4318C54.639 32.6654 54.267 32.4912 54.267 32.1777C54.267 31.8642 54.5714 31.481 55.7553 30.7145C56.4656 30.8539 57.5142 30.9932 58.4951 30.9932C62.6218 30.9932 65.3955 29.0075 65.3955 25.0361C65.3955 22.7369 64.1439 21.5176 62.8247 20.6118C62.6556 19.7758 62.588 19.079 62.588 18.5216C62.588 16.3617 63.6027 16.2224 64.0424 16.2224C64.7528 16.2224 64.9557 16.7449 64.8542 17.3023L63.9071 17.8946C63.9748 19.079 64.8542 19.7061 65.869 19.7061C66.9852 19.7061 68 19.0093 68 17.4068C68 15.7347 66.8499 14.8289 65.2602 14.8289C63.8733 14.8289 61.9453 15.665 61.9453 18.5216C61.9453 19.0442 62.0129 19.6016 62.1482 20.2286C61.032 19.6016 60.0511 19.3577 58.3936 19.3577C53.286 19.3577 51.0874 21.9008 51.0874 25.1755C51.0874 28.0669 52.3727 29.7043 55.0111 30.4707C52.3727 32.108 51.155 33.0835 51.155 35.0692C51.155 35.2642 51.1731 35.464 51.2114 35.6614H49.8336V25.1755C49.8336 20.9602 47.7364 19.3577 44.5907 19.3577C41.242 19.3577 40.1258 21.1692 39.5507 22.9111V19.7084H31.3988V20.3355H33.2592V35.6637H29.5452V19.7084H8.15188V13.6119L1.86039 15.2144V19.7084H0V20.3355H1.86039V31.3091C1.86039 35.6289 4.26198 36.6391 7.61068 36.6391C11.1916 36.6391 11.8727 34.1309 12.1771 31.4136L11.6021 31.3439C11.2976 33.7128 10.8805 35.2457 9.64019 35.2457C8.45631 35.2457 8.15188 34.1309 8.15188 32.0755V20.3355H13.8751V38.2416C13.8751 43.2582 13.503 44.4078 11.9809 44.4078C10.8308 44.4078 10.0529 43.3975 10.8308 42.1434H12.1162C12.2177 41.7253 12.3192 41.1679 12.3192 40.6802C12.3192 39.1822 11.5073 37.9978 9.71461 37.9978C8.02335 37.9978 6.60269 39.0429 6.60269 41.1331C6.60269 42.9098 7.92187 45 12.0147 45C18.0018 45 20.1666 40.5409 20.1666 33.2948V20.3355H23.2537V35.6637H21.3933V36.2908H41.0075V35.6637H39.553V26.0487C39.553 23.2269 40.8722 21.0322 42.2928 21.0322C43.1385 21.0322 43.5444 21.3806 43.5444 24.3417V35.6637H42.1575V36.2908H51.4189C51.9353 37.3893 53.3041 38.3113 56.2626 38.3113H59.5437C63.0953 38.3113 63.8395 38.9732 63.8395 40.6454C63.8395 42.8401 61.9453 44.3381 58.3598 44.3381C54.7405 44.3381 54.0302 42.8053 54.0302 41.3421C54.0302 40.7847 54.0978 40.1925 54.3008 39.4261L52.2713 38.4855C51.0874 38.8339 49.6667 39.5306 49.6667 41.2724C49.6667 43.5368 52.136 45 58.0216 45C64.8543 45 67.5603 42.213 67.5603 38.3462C67.5603 33.606 63.7042 32.6654 59.8819 32.6654ZM56.7362 24.4114C56.7362 20.6142 57.4127 19.9871 58.3598 19.9871C59.2731 19.9871 59.8143 20.5097 59.8143 24.4114V26.1184C59.8143 29.7414 59.2393 30.2988 58.326 30.2988C57.3112 30.2988 56.7362 29.5673 56.7362 26.2926V24.4114Z",
      fill: "#192C27"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.1666 15.3282C24.2765 15.3282 27.6082 11.8969 27.6082 7.66412C27.6082 3.43134 24.2765 0 20.1666 0C16.0568 0 12.7251 3.43134 12.7251 7.66412C12.7251 11.8969 16.0568 15.3282 20.1666 15.3282Z",
      fill: "#192C27"
    })
  ])
], -1)
const _hoisted_4 = { class: "Majblomman__Section" }
const _hoisted_5 = { class: "Majblomman__TopContent" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Prova Tjing så får du 50kr att ge till Majblomman", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Läs mer")
const _hoisted_9 = { class: "Majblomman__Badge" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "Majblomman__BadgeText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__BadgeHeader" }, "Tjing - Veckopeng"),
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__BadgeBrod" }, "Lär barn hantera pengar")
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Hämta")
const _hoisted_13 = { class: "Majblomman__Section Majblomman__SectionReadMore" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11.5 11.5M22 22L11.5 11.5M11.5 11.5L22 1M11.5 11.5L1 22",
    stroke: "#192C27",
    "stroke-width": "1.5"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Stäng", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "Majblomman__SectionReadMoreContent" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Vi lägger hellre pengar på barnen än på reklam"),
  /*#__PURE__*/_createElementVNode("p", null, " Tjing är en gratis veckopengs-app med syfte att hjälpa barn att få en sund relation till pengar och därmed en bättre start i livet. Men för att kunna hjälpa fler så behöver vi nå ut till fler, vilket kostar. Pengar som vi hellre ger till ekonomiskt utsatta barn än på reklam. Så hjälp oss nå ut, så skänker vi oavkortat 50kr till Majblomman för varje ny familj som väljer att testa Tjing. "),
  /*#__PURE__*/_createElementVNode("h1", null, "Om Majblomman"),
  /*#__PURE__*/_createElementVNode("p", null, " Majblomman är en ideell barnrättsorganisation som arbetar för att motverka barnfattigdomen i Sverige. Genom att dela ut ekonomiskt stöd, påverka beslut och finansiera forskning ger vi barn i Sverige det de har rätt till. "),
  /*#__PURE__*/_createElementVNode("h1", null, "Tjing - Kul veckopeng"),
  /*#__PURE__*/_createElementVNode("p", null, " Tjing har till syfte att hjälpa barn att få en sund relation till pengar genom ett kul sätt göra pengar greppbara. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", { class: "Majblomman__TrailerContainerHeader" }, "Trailer:"),
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "340",
    height: "300",
    src: "https://www.youtube.com/embed/W496Mh3dlOQ",
    title: "Tjing",
    frameborder: "0",
    allowfullscreen: "",
    class: "Majblomman__TrailerContainer"
  }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_18 = { class: "Majblomman__ReadMoreBadge" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "Majblomman__ReadMoreBadgeText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__ReadMoreBadgeHeader" }, "Tjing - Veckopeng"),
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__ReadMoreBadgeBrod" }, "Lär barn hantera pengar")
], -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Hämta")
const _hoisted_22 = { class: "Majblomman__Section Majblomman__SectionDownload" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11.5 11.5M22 22L11.5 11.5M11.5 11.5L22 1M11.5 11.5L1 22",
    stroke: "#192C27",
    "stroke-width": "1.5"
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Stäng", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "Majblomman__SectionDownloadTop" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "Majblomman__SectionDownloadTopText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__SectionDownloadTopHeader" }, "Tjing - Veckopeng"),
  /*#__PURE__*/_createElementVNode("span", { class: "Majblomman__SectionDownloadTopBrod" }, "Lär barn hantera pengar")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", null, " Scanna QR-koden för att installera Tjing på din mobil eller tablet och samtidigt skänka 50-kronan till Majblomman ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Använd mobilkameran för att scanna", -1)
const _hoisted_31 = { class: "Majblomman__SectionDownloadButtons" }
const _hoisted_32 = { href: "https://apps.apple.com/app/apple-store/id1584645121?pt=122742704&ct=majblomman&mt=8" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { href: "https://play.google.com/store/apps/details?id=com.tjing.app&referrer=utm_source%3Dwebsite%26utm_medium%3Dorganic%26utm_campaign%3Dmajblomman" }
const _hoisted_35 = ["src"]

import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import globalRenderer from '@/shared/misc/global-renderer'
import { Interface } from '@/shared/di/interface'
import { container } from 'tsyringe'
import VaultExperienceMajblomman from '../experience/vault-experience-majblomman'
import { IVaultExperience } from '../experience/vault-experience-base'
import { WalletFaceParser } from '@/shared/di/interface/walletfaces'
import { ISize } from '@/shared/di/interface/size'
import { WALLET_MENU_HEIGHT } from '@/shared/manager/size'
import { Asset, ContentType, TokenType, UpdateInfo } from '@/state/vault/domain'
import Currency from '@/common/currency'
import BaseButton from '@/features/shared/components/BaseButton.vue'
import FadingQRCode from '@/features/shared/components/FadingQRCode.vue'
import QRCode from 'qrcode'

enum Section {
  Coin = 'coin',
  Readmore = 'readmore',
  Download = 'download'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Majblomman',
  setup(__props) {

const currentSection = ref(Section.Coin)

//test
//const shortId = 'qDsqQkXjQQWYPKzkpBKRog'

//prod
const shortId = 'I846fpvcSOyJoubtxgToGA'

const qrImageSrc = ref('')
//const actionUrl = 'https://open-test.tjing.com/l/' + shortId
//prod
const actionUrl = 'https://open.tjing.com/l/' + shortId

const canShare = ref(false)
const isLoadingScreen = ref(true)
const loadingScreenEl = ref<HTMLElement | null>(null)
const threeTargetContainer = ref<HTMLElement | null>(null)

const isMobile = ref(false)
isMobile.value = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(String(navigator.userAgent))

watch(
  () => currentSection.value,
  newSection => {
    if (newSection === Section.Download) {
      QRCode.toDataURL(actionUrl)
        .then((url: string) => {
          qrImageSrc.value = url
        })
        .catch(() => {})
    }
  }
)

let experience: IVaultExperience | undefined

try {
  if (navigator.canShare) {
    canShare.value = navigator.canShare({ url: 'https://tjing.com/majblomman' })
  }
} catch (err: any) {
  console.log('cant share')
}

onMounted(() => {
  container.resolve<ISize>(Interface.ISize).setMenuHeight(WALLET_MENU_HEIGHT)

  if (threeTargetContainer.value) {
    ;(threeTargetContainer.value as HTMLElement).appendChild(globalRenderer.el)
  }

  document.getElementById('splashScreen')!.style.display = 'none'

  if (!experience) {
    experience = new VaultExperienceMajblomman()
    experience.onWalletFaceLoadComplete.add(onExperienceWalletFaceLoadComplete)

    experience.init(WalletFaceParser.Majblomman)
  }

  nextTick(() => {
    onResize()
  })
})

onBeforeUnmount(() => {
  if (experience) {
    experience.onWalletFaceLoadComplete.remove(onExperienceWalletFaceLoadComplete)
    experience.destroy()
    experience = undefined
  }
})

const onExperienceWalletFaceLoadComplete = () => {
  experience!.assetsUpdate(
    [
      {
        id: 'FakeTing:1',
        d: 100,
        c: Currency.MAJBLOMMACOIN,
        va: 'majblommacoin',
        t: TokenType.Ting,
        ux: {
          user: {
            room: 'majblomman-wallet',
            posx: 1,
            posy: -400,
            fixedRotation: [-0.1, 0.0, 0.3]
          }
        }
      } as Asset
    ],
    { refSource: '' } as UpdateInfo
  )

  experience!.enable()
}

const clickedBegin = () => {
  if (isMobile.value) {
    window.location.href = actionUrl
  } else {
    currentSection.value = Section.Download
  }
}

const clickedReadMore = () => {
  currentSection.value = Section.Readmore
  nextTick(() => {
    onResize()
  })
}

const clickedBack = () => {
  currentSection.value = Section.Coin
  nextTick(() => {
    onResize()
  })
}

const clickedShare = () => {
  navigator.share({ url: 'https://tjing.com/majblomman' })
}
/*
const hideLoadingScreen = () => {
  if (threeTargetContainer.value) {
    ;(threeTargetContainer.value as HTMLElement).appendChild(globalRenderer.el)
  }

  if (isLoadingScreen.value && loadingScreenEl.value) {
    gsap.killTweensOf(loadingScreenEl.value)

      native.hideLottieSplashScreen()

      gsap.to(loadingScreenEl.value as HTMLElement, {
        duration: 0.4,
        opacity: 0,
        delay: 0.3,
        ease: Sine.easeOut,
        onComplete: () => {
          isLoadingScreen.value = false
        }
      })
    }
  }
}

const onLoadingScreenHidden = () => {

}
*/

const getCloseButtonGradientStyle = () => {
  const templateColorFrom = '#c4d8d400'
  const templateColorTo = '#fffef4'
  return {
    background: `linear-gradient(${templateColorFrom}, ${templateColorTo})`
  }
}

window.onresize = () => {
  onResize()
}

const onResize = () => {
  let extraHeight = 0
  if (window.innerHeight === window.screen.height && navigator.userAgent.match(/instagram/i)) {
    // here apply the fixes
    extraHeight += 100
  }

  let button = document.querySelector('.Majblomman__Badge') as HTMLElement
  if (button) {
    const margin = window.innerWidth > 799 ? 30 : 0
    button.style.top = `${window.innerHeight - button.clientHeight - extraHeight - margin}px`
  }

  button = document.querySelector('.Majblomman__ReadMoreBadge') as HTMLElement
  if (button) {
    const margin = window.innerWidth > 799 ? 5 : 0.2
    button.style.top = `calc(${window.innerHeight - button.clientHeight} - ${margin}vh`
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: `https://api.tjng.co/link/e/${shortId}/visit`,
      width: "1",
      height: "1",
      alt: "",
      style: { position: 'absolute', opacity: 0 }
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      ref_key: "threeTargetContainer",
      ref: threeTargetContainer,
      class: "threeContainer"
    }, null, 512),
    _hoisted_3,
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: require(`./images/majblomma.png`),
          width: "113",
          height: "97"
        }, null, 8, _hoisted_6),
        _hoisted_7,
        _createVNode(BaseButton, {
          class: "Majblomman__ReadMoreBtn",
          theme: "black",
          outline: "",
          onClick: clickedReadMore
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          class: "Majblomman__BadgeImage",
          src: require(`./images/app-icon.png`),
          width: "69",
          height: "69"
        }, null, 8, _hoisted_10),
        _hoisted_11,
        _createVNode(BaseButton, {
          class: "Majblomman__BadgeButton",
          theme: "black",
          "text-color": "#DFECE9",
          onClick: clickedBegin
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, currentSection.value === Section.Coin]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        class: "Majblomman__ReadMoreCloseBtn",
        onClick: clickedBack
      }, _hoisted_16),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("img", {
          class: "Majblomman__ReadMoreBadgeImage",
          src: require(`./images/app-icon.png`),
          width: "69",
          height: "69"
        }, null, 8, _hoisted_19),
        _hoisted_20,
        _createVNode(BaseButton, {
          class: "Majblomman__ReadMoreBadgeButton",
          theme: "black",
          onClick: clickedBegin
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "OverflowTopGradient",
        style: _normalizeStyle(getCloseButtonGradientStyle())
      }, null, 4),
      _createElementVNode("div", {
        class: "OverflowBottomGradient",
        style: _normalizeStyle(getCloseButtonGradientStyle())
      }, null, 4)
    ], 512), [
      [_vShow, currentSection.value === Section.Readmore]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", {
        class: "Majblomman__CloseBtn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (currentSection.value = Section.Coin))
      }, _hoisted_25),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("img", {
          class: "Majblomman__SectionDownloadTopImage",
          src: require(`./images/app-icon.png`),
          width: "69",
          height: "69"
        }, null, 8, _hoisted_27),
        _hoisted_28
      ]),
      _hoisted_29,
      _createVNode(FadingQRCode, {
        src: qrImageSrc.value,
        width: "200",
        height: "200",
        class: "Majblomman__SectionDownloadCode"
      }, null, 8, ["src"]),
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("a", _hoisted_32, [
          _createElementVNode("img", {
            src: require(`./images/appstore-badge.png`),
            width: "auto",
            height: "40"
          }, null, 8, _hoisted_33)
        ]),
        _createElementVNode("a", _hoisted_34, [
          _createElementVNode("img", {
            src: require(`./images/googleplay-badge.png`),
            width: "auto",
            height: "40"
          }, null, 8, _hoisted_35)
        ])
      ])
    ], 512), [
      [_vShow, currentSection.value === Section.Download]
    ])
  ]))
}
}

})